<div class="dialog-title-content">
  <div class="dialog-title">{{ 'Сторнувати акт' }}</div>
  <div class="dialog-close" (click)="closeDialog(false)">
    <mat-icon>close</mat-icon>
  </div>
</div>
<div class="dialog-content">
  <div class="dialog-form scroll-content-padding df-c gap20" autocomplete="off">
    <span>За актом <b>{{data.actName}}</b> зареєстровано податкову накладну, тому він не видаляється, а сторнується коригуванням боргу.</span>

    <mat-form-field appearance="outline" class="no-padding full-width" floatLabel="always">
      <mat-label>Причина сторнування</mat-label>
      <textarea cdkTextareaAutosize cdkAutosizeMinRows="2" cdkAutosizeMaxRows="10" matInput type="text" [formControl]="reason"></textarea>
      <mat-error *ngIf="reason.invalid">Причина обов'язкова</mat-error>
    </mat-form-field>
  </div>
</div>

<div class="buttons-row df gap20 ai-c jc-e">
  <button class="default-button cancel-button" (click)="closeDialog(false)">
    {{'common.buttons.no' | translate}}
  </button>
  <button class="default-button apply-button" (click)="submitForm()">
    {{'common.buttons.yes' | translate}}
  </button>
</div>
